export const DELIVERY_PRICE_ADDITION = {
    NONE : 1,
    PERCENT : 2,
    YEN:3
}